// extracted by mini-css-extract-plugin
export var aboveInput = "_o1-0";
export var actionButton = "_o1-5";
export var actionButtonContainer = "_o1-1";
export var actionIcon = "_o1-6";
export var aiInfoContainer = "_o1-2";
export var attachmentWrapper = "_o1-7";
export var bold = "_o1-3";
export var checkIcon = "_o1-8";
export var clickingRecipientBar = "_o1-11";
export var commentThreadSwitch = "_o1-a";
export var draftImage = "_o1-b";
export var draftImageContainer = "_o1-c";
export var draftImages = "_o1-e";
export var editButton = "_o1-g";
export var editor = "_o1-f";
export var editorContainer = "_o1-y";
export var editorErrorTooltipWrapper = "_o1-9";
export var headerDivider = "_o1-h";
export var icon = "_o1-i";
export var info = "_o1-j";
export var internal = "_o1-n";
export var internalDivider = "_o1-k";
export var internalMessage = "_o1-l";
export var messageInputCard = "_o1-m";
export var messageInputForm = "_o1-o";
export var messageInputFormInternal = "_o1-p";
export var options = "_o1-q";
export var publicMessageCustomer = "_o1-s";
export var publicMessageMerchant = "_o1-r";
export var removeImageButton = "_o1-d";
export var replyButtons = "_o1-t";
export var showSignatureButton = "_o1-u";
export var spinner = "_o1-v";
export var verticalButtonDivider = "_o1-4";
export var visibilitySelector = "_o1-w";
export var warning = "_o1-x";
export var wrappingText = "_o1-z";
export var writingInternalNoteTopBorder = "_o1-10";